module.exports = __webpack_public_path__ + "img/文件.fde2cb5a.svg";